module.exports = __webpack_public_path__ + "static/media/Settings-4.bad61e4a.png";